/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path modules
 * @description App module registry
 */
import { useParams } from "react-router-dom";
import { QPRModule, ModuleRoute, ToolbarType, RouteModule } from "./types";
const ActiveModules: QPRModule[] = [];
const Routes: Record<string, RouteModule> = {};
const allRoutes: ModuleRoute[] = [];
const allModuleNames: string[] = [];
const allToolbars: Record<string, ToolbarType> = {};
const enabledModules: Record<string, boolean> = {};
const enabled = (process.env.REACT_APP_ENABLED_MODULES || "")
  .split(",")
  .map((v) => v.trim())
  .filter((v) => v);
enabled.forEach((mod) => {
  enabledModules[mod] = true;
});
export const addModule = (module: QPRModule) => {
  ActiveModules.push(module);
  module.routes?.forEach((r) => {
    Routes[r.path] = { module, route: r };
    allRoutes.push(r);
  });
  Object.entries(module.toolbars || {}).forEach(([key, value]) => {
    allToolbars[key] = value;
  });
  allModuleNames.push(module.moduleName);
};
export const getModuleForRoute = (path: string): QPRModule | undefined => {
  return Routes[path]?.module;
};
export const isEnabledModule = (module: QPRModule) => {
  return enabledModules[module.moduleName];
};
export const getModuleRoutes = (): ModuleRoute[] => {
  return allRoutes;
};
export const getModuleToolbars = () => {
  return allToolbars;
};
export const getModuleNames = () => {
  return allModuleNames;
};
/**
 * Will return the active module to a React component
 */
export const useActiveModule = () => {
  const params = useParams<{
    id: string;
    meaId: string;
    period: string;
    model: string;
    module: string;
  }>();
  return getModuleForRoute(params.id);
};
/**
 * Will return the active module to a React component
 */
export const useActiveModuleRoute = () => {
  const params = useParams<{
    id: string;
    meaId: string;
    period: string;
    model: string;
    module: string;
  }>();
  const route = Routes[params.id];
  if (route && isEnabledModule(route.module)) {
    return route.route;
  }
  return undefined;
};
